import type { App } from 'vue'
import type { Log } from '../../shared/log'
import { createConsola } from 'consola/browser'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'
import createLog from '../../shared/createLog'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig().public
  const log = createLog(
    createConsola,
    config.storefront.log.name,
    config.storefront.log.level,
  )
  const coreLog = log.space('sfc')
  coreLog.debug('Attached client-side logger')
  addClientSideErrorHandling(log, nuxtApp.vueApp)
  return {
    provide: {
      log,
      coreLog,
    },
  }
})

function addClientSideErrorHandling(log: Log, app: App<Element>) {
  app.config.warnHandler = (msg, vm, trace) => {
    log.space('warnHandler').warn(msg, {
      vmOptions: vm?.$options,
      trace,
      component: vm?.$options.__name,
    })
  }
  app.config.errorHandler = (error, vm, info) => {
    log.space('errorHandler').error(error as any, {
      vmOptions: vm?.$options,
      info,
      component: vm?.$options.__name,
    })
  }
}
